<template>
  <v-app-bar
    app
    dark
    tabs
    fixed
    :flat="true"
    color="primary"
    id="main-toolbar"
  >
    <v-toolbar-title>
      <!-- Back button -->
      <v-btn
        icon
        @click="backButtonHandler(false)"
        class="hidden-md-and-down"
        v-if="$route.path !== '/'"
      >
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
      <v-btn
        icon
        @click="backButtonHandler(true)"
        class="hidden-lg-and-up"
      >
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>

      <!-- Menu button -->
      <v-app-bar-nav-icon
        @click.stop="mainMenuMiniVariant = !mainMenuMiniVariant"
        class="hidden-md-and-down"
      ></v-app-bar-nav-icon>
      <v-app-bar-nav-icon
        @click.stop="toggleMenuForMobile"
        class="hidden-lg-and-up"
      ></v-app-bar-nav-icon>

      <!-- Title -->
      {{ title || 'ללא כותרת' }}
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn
      v-if="actionButton && shouldShow(actionButton.roles, user)"
      color="secondary"
      large
      @click="envokeMethodByName(actionButton.click)"
    >
      {{ actionButton.title }}
    </v-btn>
    <template
      v-slot:extension
      v-if="tabs"
    >
      <v-tabs
        slot="extension"
        align-with-title
        background-color="transparent"
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.path"
          :to="tab.path"
          :replace="false"
          exact
        >{{ tab.title }}</v-tab>
        <v-tabs-slider color="secondary"></v-tabs-slider>
      </v-tabs>
    </template>
  </v-app-bar>
</template>

<script>
import generateId from "@/idGenerator";
import shouldShow from "@/utils/shouldShow";
import colors from "vuetify/es5/util/colors";
import { camelCase } from "lodash";

export default {
  data: () => ({
    newEventDialog: false,
    loading: false,
    isFirstPage: true,
    barData: [
      {
        routeNames: ["Dashboard"],
        title: "לוח בקרה"
      },
      {
        routeNames: ["Tasks"],
        title: "משימות",
        actionButton: {
          title: "משימה חדשה",
          click: "createTask"
        }
      },
      {
        routeNames: ["Task"],
        title: "משימה"
      },
      {
        routeNames: ["Invoices"],
        title: "חשבוניות"
      },
      {
        routeNames: ["Devices"],
        title: "מכשירים",
        actionButton: {
          title: "העברת חנות",
          click: "storeTransfer"
        }
      },
      {
        routeNames: ["Device"],
        title: "מכשיר"
      },
      {
        routeNames: ["Customers"],
        title: "לקוחות",
        actionButton: {
          title: "לקוח חדש",
          click: "createCustomer"
        }
      },
      {
        routeNames: ["Customer"],
        title: "לקוח/ה"
      },
      {
        routeNames: ["Orders"],
        title: "הזמנות"
      },
      {
        routeNames: ["Order"],
        title: "הזמנה"
      },
      {
        routeNames: ["Deliveries"],
        title: "משלוחים",
        actionButton: {
          title: "משלוח חדש",
          click: "createDelivery"
        }
      },
      {
        routeNames: ["Delivery"],
        title: "משלוח"
      },
      {
        routeNames: ["Reports", "ActivityLogs"],
        title: "דו״חות",
        tabs: [
          {
            title: "לוג פעולות",
            path: "/reports/activity-logs"
          }
        ]
      },
      {
        routeNames: ["SystemSetup", "Users", "BulkActions"],
        title: "הגדרות מערכת",
        tabs: [
          {
            title: "כללי",
            path: "/system-setup"
          },
          {
            title: "משתמשים",
            path: "/system-setup/users"
          },
          {
            title: "פעולות Bulk",
            path: "/system-setup/bulk-actions"
          }
        ]
      },
      {
        routeNames: ["StockReport", "OrdersReport"],
        title: "דו״חות",
        tabs: [
          {
            title: "מלאי",
            path: "/reports"
          },
          {
            title: "הזמנות",
            path: "/reports/orders"
          }
        ]
      }
    ]
  }),

  computed: {
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    },
    storeTransferDialog: {
      get() {
        return this.$store.state.storeTransferDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_STORE_TRANSFER_DIALOG", isActive);
      }
    },
    isMainMenuActive: {
      get() {
        return this.$store.getters["isMainMenuActive"];
      },
      set(isActive) {
        this.$store.dispatch("TOGGLE_MAIN_MENU", { isActive });
      }
    },
    mainMenuMiniVariant: {
      get() {
        return this.$store.getters["mainMenuMiniVariant"];
      },
      set(isActive) {
        this.$store.dispatch("SET_MAIN_MENU_MINI_VARIANT", { isActive });
      }
    },
    shouldShowMainMenuAutomatically: {
      get() {
        return this.$store.getters["shouldShowMainMenuAutomatically"];
      },
      set(payload) {
        this.$store.dispatch("SET_SHOULD_SHOW_MAIN_MENU_AUTOMATICALLY", {
          payload
        });
      }
    },
    activePageBarData() {
      // let activePath = this.$route.path;
      let routeName = this.$route.name;
      let activePageBarData = this.barData.find(item => {
        let paths = item.routeNames;
        let path = paths.find(item2 => {
          return routeName === item2;
        });
        return path ? true : false;
      });
      return activePageBarData;
    },
    title() {
      let activePageBarData = this.activePageBarData;
      if (activePageBarData) {
        return activePageBarData.title;
      } else {
        return null;
      }
    },
    tabs() {
      let activePageBarData = this.activePageBarData;
      if (activePageBarData) {
        return activePageBarData.tabs;
      } else {
        return null;
      }
    },
    actionButton() {
      let activePageBarData = this.activePageBarData;
      if (activePageBarData) {
        return activePageBarData.actionButton;
      } else {
        return null;
      }
    },
    user() {
      return this.$store.getters["user/user"];
    }
  },

  methods: {
    envokeMethodByName(name) {
      this[name]();
    },
    backButtonHandler(isMobile) {
      if (isMobile) {
        this.shouldShowMainMenuAutomatically = false;
      } else {
        this.shouldShowMainMenuAutomatically = true;
      }
      if (this.isFirstPage) {
        this.$router.push("/");
      } else {
        this.$router.go(-1);
      }
    },
    toggleMenuForMobile() {
      this.isMainMenuActive = !this.isMainMenuActive;
      this.mainMenuMiniVariant = false;
    },
    shouldShow,
    userAvatar(user) {
      if (user) {
        if (user.image) {
          return user.image;
        } else {
          return `https://ui-avatars.com/api/?name=${
            user.name
          }&background=${this.userAvatarColor(
            user
          )}&size=80&color=ffffff&rounded=1&length=1`;
        }
      }
    },
    userAvatarColor(user) {
      if (user) {
        let color = user.color;
        if (color) {
          color = camelCase(color);
        } else {
          color = "blue";
        }
        return colors[color].base.substr(1);
      } else {
        return null;
      }
    },
    editResource(entity, resource, isNew = false) {
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew
      });
      this.entityEditDialog = true;
    },

    // Tasks
    createTask() {
      let newEntity = { _id: generateId() };
      let resource = this.$store.state.resources.task;
      this.editResource(newEntity, resource, true);
    },

    // Customers
    createCustomer() {
      let newEntity = { _id: generateId() };
      let resource = this.$store.state.resources.customer;
      this.editResource(newEntity, resource, true);
    },

    // Delivery
    createDelivery() {
      let newEntity = { _id: generateId() };
      let resource = this.$store.state.resources.delivery;
      this.editResource(newEntity, resource, true);
    },

    // StoreTransfers
    storeTransfer() {
      this.storeTransferDialog = true;
    }
  },

  components: {},

  watch: {
    "$route.path": function() {
      this.isFirstPage = false;
    }
  }

  // beforeMount() {
  //   this.selectedCountry = this.$route.params.id || null;
  // }
};
</script>

<style scoped>
</style>
